import { CurrentUserData } from '../../../hooks/authentication/useCurrentUserData/useCurrentUserData';
import { UserGroup } from '../../entities/UserGroup/userGroupTypes';
export class UserPermissions {
  constructor(private readonly userData: CurrentUserData) {}
  public canEditUsers(): boolean {
    return this.userData.user.admin;
  }
  public canEditUserGroups(): boolean {
    return this.userData.user.admin;
  }
  public canEditTimeTrackingConfigurations(): boolean {
    return this.userData.adminUserGroups.length > 0;
  }
  public canEditTimeTrackingActivityCompilationsOfUserGroup(userGroupId: string): boolean {
    return !!this.userData.adminUserGroups.find(ug => ug.id === userGroupId);
  }
  public getEditableUserGroupsForTimeTrackingActivityCompilations(): Array<UserGroup> {
    return this.userData.adminUserGroups;
  }
  public canEditWorkTimeEntriesOfUserGroup(userGroupId: string): boolean {
    return !!this.getEditableUserGroupsForWorkTimeEntries().find(ug => ug.id === userGroupId);
  }
  public canEditConstructionSites(): boolean {
    return this.userData.adminUserGroups.length > 0;
  }
  public getEditableUserGroupsForWorkTimeEntries(): Array<UserGroup> {
    return this.userData.adminUserGroups;
  }
  public canEditTimeTrackingActivitiesOfUserGroup(userGroupId: string): boolean {
    return !!this.userData.adminUserGroups.find(ug => ug.id === userGroupId);
  }
  public getEditableUserGroupsForTimeTrackingConfigurations(): Array<UserGroup> {
    return this.userData.adminUserGroups;
  }
  public getEditableUserGroupsForConstructionSites(): Array<UserGroup> {
    return this.userData.adminUserGroups;
  }
  public getUserGroupsForExport(): Array<UserGroup> {
    return this.userData.adminUserGroups;
  }
  public canEditConstructionSitesOfUserGroup(userGroupId: string): boolean {
    return !!this.getEditableUserGroupsForConstructionSites().find(ug => ug.id === userGroupId);
  }
}